import React from 'react';
import { flagshipProject } from '../data/projects';
import { FlagshipProject } from '../types';

export default function Flagship() {
  const { title, badge, tagline, problem, solution, stack, pipelineStages, guardrails }: FlagshipProject = flagshipProject;

  return (
    <section id="flagship" className="flagship-section">
      <div className="wrap">
        <div className="eyebrow">Flagship AI Architecture</div>
        <h2 className="sectitle">Enterprise Natural Language-to-SQL Agent</h2>
        <p className="secintro">
          Solo-architected multi-agent system translating natural language into safe, verified SQL queries across 400+ tables with dynamic RAG schema retrieval, AST-level guardrails, Keycloak RBAC, and human approval gates.
        </p>

        <div className="flagship">
          <div className="flagship-banner">
            <div className="flagship-header-left">
              <span className="flagship-badge">{badge}</span>
              <h3 className="flagship-title">{title}</h3>
              <p className="flagship-tagline">{tagline}</p>
            </div>
          </div>

          <div className="flagship-problem-solution-grid">
            <div className="ps-box ps-problem">
              <div className="ps-tag">Enterprise Challenge</div>
              <h4>Schema-Scale Limits &amp; Mutation Risk</h4>
              <p>{problem}</p>
            </div>
            <div className="ps-box ps-solution">
              <div className="ps-tag">Architectural Solution</div>
              <h4>Governed 5-Stage Agentic Pipeline</h4>
              <p>{solution}</p>
            </div>
          </div>

          <div className="flagship-stages-grid">
            {pipelineStages.map((stage) => (
              <div className="stage-card" key={stage.id}>
                <div className="stage-card-header">
                  <span className="stage-card-num">{stage.step}</span>
                  <span className="stage-card-tech">{stage.tech.split('·')[0]}</span>
                </div>
                <h4 className="stage-card-title">{stage.title}</h4>
                <p className="stage-card-desc">{stage.shortDesc}</p>
                <ul className="stage-card-bullets">
                  {stage.highlights.map((item) => (
                    <li key={`${stage.id}-hl-${item.slice(0, 24)}`}>{item}</li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          <div className="flagship-footer-grid">
            <div className="flagship-guardrails-panel">
              <div className="stacklabel">Core Enterprise Guardrails</div>
              <div className="guardrails-list">
                {guardrails.map((g) => (
                  <div className="guardrail-item" key={g.label}>
                    <strong>{g.label}:</strong> {g.desc}
                  </div>
                ))}
              </div>
            </div>

            <div className="flagship-stack-panel">
              <div className="stacklabel">Architecture Tech Stack</div>
              <div className="stackchips">
                {stack.map((chip) => (
                  <span className="chip" key={chip}>{chip}</span>
                ))}
              </div>
              <div className="flagship-status-note">
                <span className="live-dot"></span>
                <span>Active POC presented to enterprise leadership to demonstrate support cost reduction and data democratization.</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
